import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Shield, MessageSquare } from 'lucide-react';
import { ContactForm } from '../components/ContactForm';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="contact-page">
      {/* Navigation */}
      <nav className="nav-glass fixed top-0 left-0 right-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#00F0FF] flex items-center justify-center">
              <Shield className="w-6 h-6 text-black" />
            </div>
            <span className="font-bold text-xl tracking-tight">Digital Associates</span>
          </Link>
          
          <div className="hidden md:flex items-center gap-8">
            <Link to="/search" className="text-[#A1A1AA] hover:text-white transition-colors">
              AI Search
            </Link>
            <Link to="/services" className="text-[#A1A1AA] hover:text-white transition-colors">
              Services
            </Link>
            <Link to="/vdi" className="text-[#A1A1AA] hover:text-white transition-colors">
              Remote Access
            </Link>
            <Link to="/contact" className="text-white transition-colors">
              Contact
            </Link>
          </div>

          <Link to="/contact">
            <Button className="bg-[#00F0FF] text-black hover:bg-[#00F0FF]/90 btn-glow font-medium">
              Get in Touch
            </Button>
          </Link>
        </div>
      </nav>

      {/* Main Content */}
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-3xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <div className="w-16 h-16 bg-[#00F0FF]/20 flex items-center justify-center mx-auto mb-6">
              <MessageSquare className="w-8 h-8 text-[#00F0FF]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Get in <span className="text-[#00F0FF]">Touch</span>
            </h1>
            <p className="text-[#A1A1AA] text-lg max-w-xl mx-auto">
              Have a question or need IT support? Fill out the form below and our team will get back to you within 24 hours.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="terminal-card"
          >
            <div className="terminal-header">
              <div className="terminal-dot red" />
              <div className="terminal-dot yellow" />
              <div className="terminal-dot green" />
              <span className="text-sm text-[#A1A1AA] ml-2 font-mono">contact-form</span>
            </div>
            <div className="p-6 md:p-8">
              <ContactForm />
            </div>
          </motion.div>

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6"
          >
            <div className="service-card p-6 text-center">
              <p className="text-sm text-[#A1A1AA] uppercase mb-2">Email</p>
              <p className="text-[#00F0FF]">support@digital-associates.co.uk</p>
            </div>
            <div className="service-card p-6 text-center">
              <p className="text-sm text-[#A1A1AA] uppercase mb-2">Phone</p>
              <p className="text-[#00F0FF]">0203 582 0582</p>
            </div>
            <div className="service-card p-6 text-center">
              <p className="text-sm text-[#A1A1AA] uppercase mb-2">Response Time</p>
              <p className="text-[#00FF94]">Within 24 hours</p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-[#27272A]">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center gap-3 mb-4 md:mb-0">
            <div className="w-8 h-8 bg-[#00F0FF] flex items-center justify-center">
              <Shield className="w-4 h-4 text-black" />
            </div>
            <span className="font-bold">Digital Associates</span>
          </div>
          <p className="text-sm text-[#A1A1AA]">
            © 2025 Digital Associates. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ContactPage;
